import { Dispatch, SetStateAction, useState } from "react";
import classNames from "classnames";
import { Typography } from "components/atoms/Typography";
import { CheckBox } from "components/atoms";
import "./index.scss";

interface IProps {
  label: string;
  color: "purple" | "green" | "blue";
  styles?: string;
  setIsChecked: Dispatch<SetStateAction<boolean>>;
  isChecked: boolean;
}

export const FilterByLabel = ({
  label,
  color,
  styles,
  isChecked,
  setIsChecked,
}: IProps) => {
  return (
    <div className="filter-label-body">
      <div
        className={classNames(
          "filter-label-wrapper",
          `filter-label-wrapper-${color}`,
          { [`${styles}`]: styles }
        )}
      >
        <CheckBox checked={isChecked} onChange={setIsChecked}/>
        <div className={classNames("typography-label")}>
          <Typography
            label={label}
            variant="h8Med"
            styles={`typography-label-${color}`}
          />
        </div>
      </div>
    </div>
  );
};
